/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {OpenChatRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {OpenChatResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const openChat = (request:OpenChatRequest, options?: CashRequestOptions) => post<OpenChatRequest, OpenChatResponse>("/2.0/cash/open-chat", request, {...options, rejectOnError: true })